const convertMessage = (message) => {
  let response = message;
  switch (message) {
    case "PERMISSION_DENIED":
      response = "ບໍ່ມີສິດໃນການເຂົ້າເຖິງ";
      break;
    case "BAD_REQUEST":
      response = "ສົ່ງຂໍ້ມູນມາບໍ່ຄົບ";
      break;
    case "INTER_SERVER_ERROR":
      response = "Server ເກີດຂໍ້ຜິດພາດ";
      break;
    case "NOT_FOUND":
      response = "ບໍ່ມີຂໍ້ມູນ";
      break;
    case "CONNECTION_ERROR":
      response = "ການເຊື່ອມຜິດພາດ";
      break;
    case "USER_NOT_FOUND":
      response = "ບໍ່ມີ user ໃນລະບົບ";
      break;
    case "USER_ALREADY_EXIST":
      response = "User ຜູ້ນີ້ມີໃນລະບົບແລ້ວ";
      break;
    case "INVALID_USERNAME_OR_PASSWORD":
      response = "Username ຫຼື Password ບໍ່ຖືກຕ້ອງ";
      break;
    case "BALANCE_IS_NOT_ENOUGH":
      response = "ຈຳນວນເງິນອອມບໍ່ພໍ";
      break;
    case "MEMBER_NOT_FOUND":
      response = "ບໍ່ເຫັນສະມາຊິກຜູ້ນິໃນລະບົບ";
      break;
    case "STAFF_NOT_FOUND":
      response = "ບໍ່ເຫັນພະນັກງານຜູ້ນິໃນລະບົບ";
      break;
    case "STAFF_ALREADY_EXIS":
      response = "ພະນັກງານຜູ້ນີ້ມີໃນລະບົບ";
      break;
    case "SUCCESS":
      response = "ສຳເລັດ";
      break;
    case "INTERNAL_SERVER_ERROR":
      response = "Server ເກີດຂໍ້ຜິດພາດ";
      break;
    case "INVALID_AUTHENTICATION":
      response = "ການເຂົ້າລະບົບບໍ່ຖືກຕ້ອງ";
      break;
    case "MEMBER_BALANCE_ALREADY_EXIST":
      response = "ສະມາຊິກຜູ້ນີ້ມີບັນຊີເງິນອອມແລ້ວ";
      break;
    case "AUTHORIZATION_REQUIRED":
      response = "ຕ້ອງໄດ້ຮັບການອະນຸຍາດ";
      break;
    case "BALANCE_NOT_FOUND":
      response = "ຍັງບໍ່ມີທັນມີການອອມເງິນ";
      break;
    case "LOAN_AMOUNT_LARGE_THAN_LIMIT":
      response = "ຈຳນວນເງິນກູ້ເກີນກຳນົດ";
      break;
    case "MEMBER_MUST_BE_AT_LEAST_18_YEARS_OLD":
      response = "ສະມາຊິກຕ້ອງມີອາຍຸ 18 ປີຂຶ້ນໄປ!";
      break;
    case "LOAN_NOT_FOUND":
      response = "ບໍ່ມີລາຍການເງິນກູ້ໃນລະບົບ";
      break;
    case "INSTALLMENT_NOT_FOUND":
      response = "ບໍ່ມີລາຍການຊຳລະງວດໃນລະບົບ";
      break;
    case "VILLAGE_NOT_FOUND":
      response = "ບໍ່ມີຂໍ້ມູນບ້ານ";
      break;
    case "INVALID_IMAGE_FORMAT":
      response = "ຮູບບໍຖືກ format";
      break;
    case "TOKEN_EXPIRED":
      response = "ໝົດເວລາການນຳໃຊ້ ກະລຸນາເຂົ້າລະບົບໃໝ່";
      break;
    case "INSTALLMENTNOTE_ALREADY_SUCCESS":
      response = "ລາຍການຊຳລະງວດ ລາຍການນີ້ແມ່ນໄດ້ຊຳລະແລ້ວ";
      break;
    case "DO_NOT_HAVE_DIVIDEND":
      response = "ຍັງບໍ່ມີຈຳນວນເງິນປັນຜົນ";
      break;
    case "DEPOSIT_AMOUNT_LARGE_THAN_LIMIT":
      response = "ຈຳນວນເງິນອອມເກີນກຳນົດ";
      break;
    case "MEMBER_ALREADY_EXISTS":
      response = "ສະມາຊິກຜູ້ນີ້ມີໃນລະບົບແລ້ວ";
      break;
    case "MEMBER_NO_ALREADY_EXISTS":
      response = "ເລກສະມາຊິກນີ້ມີໃນລະບົບແລ້ວ";
      break;
    case "MEMBER_NOT_FINISH_OTHER_LOAN":
      response = "ສະມາຊິກນີ້ຍັງມີລາຍການປ່ອຍກູ້ຢູ່";
      break;
    case "MANAGER_CANNOT_BE_DELETED":
      response = "ບໍ່ມີສິດໃນການລົບບັນຊີ Manager";
      break;
    case "THIS_MEMBER_IS_STILL_IN_DEBT":
      response =
        "ສະມາຊິກຜູ້ນີ້ ຍັງມີຍອດກູ້ຍືມ, ບໍ່ສາມາດຍົກເລີກການເປັນສະມາຊິກ ຫຼື ລຶບບັນຊີໄດ້";
      break;
    case "THIS_MEMBER_HAS_A_DEPOSIT":
      response =
        "ສະມາຊິກຜູ້ນີ້ຍັງມີຍອດເງິນອອມຄົງຄ້າງບັນຊີ, ຖ້າຕ້ອງການລຶບບັນຊີ ຫຼື ຍົກເລີກການເປັນສະມາຊິກ, ກະລຸນາຖອນເງີນອອມ ອອກຈາກບັນຊີກ່ອນ ຈຶ່ງສາມາດດຳເນີນລາຍການໄດ້";
      break;
    case "ACTIVITY_IS_NOT_CREATED_TODAY":
      response = "ບໍ່ສາມາດແກ້ໄຂ ຫຼື ລຶບ ລາຍການຂອງມື້ກ່ອນໄດ້";
      break;
    case "ACTIVITY_IS_NOT_THE_LASTEST":
      response =
        "ທ່ານສາມາດແກ້ໄຂ ຫຼື ລຶບ, ໄດ້ພຽງແຕ່ທຸລະກຳລ່າສຸດຂອງສະມາຊິກດັ່ງກ່າວເທົ່ານັ້ນ";
      break;
    case "CAN_NOT_SKIP_INSTALLMENTS":
      response = "ບໍ່ສາມາດຊຳລະຂ້າມງວດໄດ້";
      break;
    case "VILLAGE_FUND_IS_NOT_ENOUGH":
      response = "ຍອດເງິນລວມຂອງກອງທຶນບໍ່ພຽງພໍ";
      break;
    case "THE_PRINCIPAL_AMOUNT_IS_TOO_MUCH":
      response = "ປ້ອນເງິນເກີນ ເງິນທີກູ້";
      break;
    case "STAFF_NO_ALREADY_EXISTS":
      response = "ເລກພະນັກງານນີ້ມີໃນລະບົບແລ້ວ";
      break;
    case "MEMBER_ALREADY_EXISTS_THIS_YEAR":
      response =
        "ເລກໄອດີສະມາຊິກດັ່ງກ່າວບໍ່ສາມາດໃຊ້ໄດ້, ເນື່ອງຈາກວ່າເຄີຍມີການໃຊ້ງານມາກ່ອນ, ແຕ່ໄດ້ຍົກເລີກການເປັນສະມາຊິກໄປແລ້ວ, ຖ້າຕ້ອງການນຳໃຊ້ ແມ່ນຕ້ອງລໍຖ້າປີຕໍ່ໄປແທນ";
      break;
    case "BALANCE_IS_LESS_THAN_THREE_TIMES_OF_LOAN":
      response =
        "ບໍ່ສາມາດຖອນໄດ້ເນື່ອງຈາກວ່າຍອດອອມໃນປະຈຸບັນ ຫຼື ຫຼັງຖອນໄປ ໜ້ອຍກວ່າ 3 ເທົ່າຂອງເງິນກູ້ຍືມ";
      break;

    default:
    // code block
  }
  return response;
};

export default convertMessage;
